import { render, staticRenderFns } from "./FieldsList.vue?vue&type=template&id=53f984a2&"
import script from "./FieldsList.vue?vue&type=script&lang=js&"
export * from "./FieldsList.vue?vue&type=script&lang=js&"
import style0 from "./FieldsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports